export enum SpecialDocViewMode {
    none,
    shortDocView,
    wideDocView,
    shortDocViewSubjectHeader
}
